import 'css-chunksrc/client/scenes/projectPortfolioCreation/styles.scss';export default {
  "projectPortfolioCreation": "_projectPortfolioCreation_5s17h_1",
  "form": "_form_5s17h_5",
  "main": "_main_5s17h_11",
  "buttons": "_buttons_5s17h_24"
};